export default __webpack_public_path__ + "static/media/fig-10-dominant-sets.2e45ce2f.jpeg";